import { ElementsProvider } from '../../core/elements';
import { DataTable } from '../../primitives/accessibility/DataTable';
import { LayoutContainer, Layout } from '../../primitives/container';
import { DimensionsWrapper } from '../../primitives/container/DimensionWrapper';
import { OrdinalLegend } from '../../primitives/legend';
import { LegendLabel } from '../../primitives/legend/OrdinalLegend';
import { MenuProvider, Menu } from '../../primitives/menu';
import { Arc } from '../../primitives/shape/Arc';
import { Theme } from '../../primitives/theme';
import { Subtitle, Title } from '../../primitives/title';
import EventEmitterProvider from '../common/events/context/EventEmitterProvider';
import TooltipProvider from '../common/events/context/TooltipProvider';
import { SingleSeriesTooltip } from '../common/tooltip/SingleSeriesTooltip';
import { DonutMetric, DonutMetricLabel, DonutMetricValue } from './elements/donut-label';
import { DonutMarkLabels } from './elements/donut-stack-labels';
import { DonutMarks } from './elements/donut-stack-marks';
import { DonutScalesElement } from './elements/scale';
import { DonutTooltipOverlay } from './elements/tooltip-overlay';
import { PureDonutChart } from './pure';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function DonutChart(_ref) {
  let {
    width,
    height,
    data,
    children,
    ...restProps
  } = _ref;
  return /*#__PURE__*/_jsx(ElementsProvider, {
    children: /*#__PURE__*/_jsx(TooltipProvider, {
      children: /*#__PURE__*/_jsx(MenuProvider, {
        children: /*#__PURE__*/_jsxs(EventEmitterProvider, {
          children: [children, /*#__PURE__*/_jsx(LayoutContainer, {
            width: width,
            height: height,
            data: data,
            gridTemplate: ['title', 'subtitle', 'plot', 'legend'],
            children: /*#__PURE__*/_jsx(DimensionsWrapper, {
              children: _ref2 => {
                let {
                  margin,
                  plotHeight,
                  plotWidth,
                  plotSvgRef
                } = _ref2;
                return /*#__PURE__*/_jsx(PureDonutChart, {
                  svgRef: plotSvgRef,
                  height: plotHeight,
                  width: plotWidth,
                  margin: margin,
                  data: data,
                  ...restProps
                });
              }
            })
          })]
        })
      })
    })
  });
}
DonutChart.elements = {
  Legend: OrdinalLegend.Component,
  LegendLabel: LegendLabel.Component,
  Layout: Layout.Component,
  Title: Title.Component,
  SubTitle: Subtitle.Component,
  Mark: Arc.Component,
  Marks: DonutMarks.Component,
  MarkLabels: DonutMarkLabels.Component,
  Metric: DonutMetric.Component,
  MetricLabel: DonutMetricLabel.Component,
  MetricValue: DonutMetricValue.Component,
  TooltipOverlay: DonutTooltipOverlay.Component,
  Tooltip: SingleSeriesTooltip.Component,
  Scales: DonutScalesElement.Component,
  Theme: Theme.Component,
  Menu: Menu.Component,
  DataTable: DataTable.Component
};